module.exports = __webpack_public_path__ + "img/com_button.abf07cec.webp";